import * as React from "react";
import { useState } from "react";
import styled, { css } from "styled-components";
import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";
import useProductName from "brand-customization/useProductName";
import { Button, Col, Modal, Row } from "components/bootstrap";
import FormikInput from "components/common/FormikInput";
import Spinner from "components/common/Spinner";
import { InputDescription, ModalSubmit, IfPermitted } from "components/common";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import useAIConfiguration from "ai/hooks/useAIConfiguration";
import useAIConfigurationMutations from "ai/hooks/useAIConfigurationMutations";
const LabelSpan = styled.span(
  ({ theme }) => css`
    margin-left: ${theme.spacings.sm};
    font-weight: bold;
  `
);
const AIReportConfiguration = () => {
  const { t } = useTranslation("enterprise_security_investigations");
  const { data, isLoading } = useAIConfiguration();
  const [showModal, setShowModal] = useState(false);
  const { enable, disable } = useAIConfigurationMutations();
  const productName = useProductName();
  const sendTelemetry = useSendTelemetry("investigation-ai-report");
  const _saveConfig = (values) => {
    const action = values.isEnabled ? enable : disable;
    action().then(() => {
      sendTelemetry(TELEMETRY_EVENT_TYPE.AI_REPORT_CONFIGURATION_SAVED, {
        app_pathname: "configurations"
      });
      setShowModal(false);
    });
  };
  const _resetConfig = () => {
    setShowModal(false);
  };
  const title = t("ai_report_config.title");
  const modalTitle = t("ai_report_config.modal_title", { title });
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h2", null, title), /* @__PURE__ */ React.createElement("p", null, t("ai_report_config.description", { productName })), isLoading ? /* @__PURE__ */ React.createElement(Spinner, null) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("dl", { className: "deflist" }, /* @__PURE__ */ React.createElement("dt", null, t("ai_report_config.status")), /* @__PURE__ */ React.createElement("dd", null, data.isEnabled ? t("ai_report_config.enabled") : t("ai_report_config.disabled"))), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "*" }, /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Button,
    {
      type: "button",
      bsSize: "xs",
      bsStyle: "info",
      onClick: () => {
        setShowModal(true);
      }
    },
    t("ai_report_config.edit_configuration")
  ))), /* @__PURE__ */ React.createElement(Modal, { show: showModal, onHide: _resetConfig }, /* @__PURE__ */ React.createElement(Formik, { onSubmit: _saveConfig, initialValues: data }, ({ isSubmitting }) => /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, modalTitle)), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { sm: 12 }, /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      type: "checkbox",
      name: "isEnabled",
      id: "isEnabled",
      label: /* @__PURE__ */ React.createElement(LabelSpan, null, t("ai_report_config.enabled"))
    }
  ), /* @__PURE__ */ React.createElement(InputDescription, { help: /* @__PURE__ */ React.createElement(React.Fragment, null, t("ai_report_config.enable_help")) }))))), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
    ModalSubmit,
    {
      onCancel: _resetConfig,
      isSubmitting,
      submitButtonText: t("ai_report_config.update_configuration"),
      submitLoadingText: t("ai_report_config.updating_configuration")
    }
  )))))));
};
export default AIReportConfiguration;
